import IMask from "imask";
import $ from "jquery";
import FileField from "./FileField";
import {ERROR_STATUS} from "../constans";
import {Helpers} from "../helpers/helpers";
import PopupManager from "../managers/PopupManager";

/**
 * Компонент обратной связи
 */
export default class FeedbackComplaints {
    private readonly $holder: JQuery;
    private readonly $form: JQuery;
    private readonly validateUrl: string;
    private readonly submitUrl: string;
    private popupManager: PopupManager;

    private ERROR_CLASS = 'has-error';
    private SHOW_ADDITIONAL_FIELD = 'show-additional-field';
    private TYPE_SUCCESS_POPUP = 'success-form';

    private selectors = {
        simpleFormHolder: '.js-simple-form-holder',
        fieldError: '.js-simple-form-error',
        fieldPhone: '.js-simple-telephone',
        additionalField: '.js-additional-field',
        additionalFieldSelectWrapper: '.js-wrapper-select-additional-block',
        successPopup: '.js-popup-complaints-success',
    }

    constructor($holder: JQuery, popupManager: PopupManager)
    {
        this.$holder = $holder;
        this.validateUrl = this.$holder.data('validate-url');
        this.submitUrl = this.$holder.data('submit-url');
        this.$form = this.$holder.find('form');
        this.popupManager = popupManager;

        this.submit = this.submit.bind(this);
        this.getRequestData = this.getRequestData.bind(this);
        this.init();
    }

    /**
     * Данные запроса
     * @private
     */
    private getRequestData(): FormData
    {
        const form = this.$form[0] as HTMLFormElement;

        return new FormData(form);
    }

    /**
     * отправка формы
     * @private
     */
    private submit()
    {
        const $currentSubmitButton = this.$form.find('button[type="submit"]');

        $currentSubmitButton.addClass('loading')
            .prop('disabled', true);

        this.clearErrors();

        $.ajax({
            url: this.submitUrl,
            type: 'POST',
            data: this.getRequestData(),
            contentType: false,
            processData: false,
            success: () => {
                $currentSubmitButton.removeClass('loading')
                    .prop('disabled', false);
                this.clearFields();
                this.popupManager.openPopupByType(this.TYPE_SUCCESS_POPUP, false);
            },
            error: (error) => {
                $currentSubmitButton.removeClass('loading')
                    .prop('disabled', false);
                if (error.status === ERROR_STATUS) {
                    this.showValidateErrors(error.responseJSON.errors);
                } else {
                    alert('Ошибка запроса');
                }

                //скролл до первой ошибки формы
                let isFindErrorField = false;
                this.$form.find(this.selectors.simpleFormHolder).each((index, field )=> {
                    if ($(field).hasClass(this.ERROR_CLASS) && !isFindErrorField) {
                        isFindErrorField = true;
                        Helpers.scrollTo(field as HTMLHtmlElement);
                    }
                });
            }
        });
    }

    /**
     * Очистка ошибок валидации
     * @private
     */
    private clearErrors()
    {
        this.$form.find(this.selectors.fieldError).html('');
        this.$form.find(this.selectors.simpleFormHolder).removeClass(this.ERROR_CLASS);
    }

    /**
     * Очистка одного поля
     * @param $field
     * @private
     */
    private clearError($field: JQuery): void
    {
        const $holderField = $field.closest(this.selectors.simpleFormHolder);
        const $error = $holderField.find(this.selectors.fieldError);

        $holderField.removeClass(this.ERROR_CLASS);
        $error.html('');
    }

    /**
     * Очистка полей формы
     * @private
     */
    private clearFields()
    {
        this.$form.find('input:text:visible, textarea:visible, input:file').val('');
        this.$form.find('input:checkbox').prop('checked', false);

        this.clearFileField();

        this.$form.find('select').each((_, element) => {
            $(element).find('option:eq(0)').prop('selected',true);
            $(element).trigger('change');
        })
    }

    /**
     * Очистка поля файла
     * @private
     */
    private clearFileField()
    {
        const $fieldsFile = this.$holder.find('.js-file-field');

        $fieldsFile.each((index, item) => {
            const fileComponent: unknown = $(item).data('fileField');

            if (!fileComponent) {
                return;
            }

            (fileComponent as FileField).reset();
        });
    }

    /**
     * Отображение ошибок валидации
     * @param errors
     * @private
     */
    private showValidateErrors(errors: {[key: string]: Array<string>}): void
    {
        for (let name in errors) {
            const $input = this.$form.find('[name="' + name + '"]');
            if (!$input.length) {
                continue;
            }

            const fieldErrors = errors[name];
            if (!fieldErrors.length) {
                continue;
            }

            let firstError = fieldErrors[0];
            const $fieldHolder = $input.closest(this.selectors.simpleFormHolder);
            $fieldHolder.addClass(this.ERROR_CLASS);
            $fieldHolder.find(this.selectors.fieldError).text(firstError);
        }
    }

    /**
     * Инициализация
     * @private
     */
    private init(): void
    {
        this.initEvents();
        this.initMasksFieldForm();
    }


    /**
     * инициализация маски
     * @private
     */
    private initMasksFieldForm(): void
    {
        this.$form.find(this.selectors.fieldPhone).each((_, item) => {
            const maskOptions = {
                mask: '+{7}(000)0000000',
                lazy: true,
            };

            const mask = IMask(item, maskOptions);

            $(item).on('focus', () => {
                mask.updateValue();
                mask.updateOptions({
                    lazy: false,
                });
            });

            $(item).on('blur', () => {
                mask.updateOptions({ lazy: true });
            });
        });
    }

    /**
     * инициализация ивентов
     * @private
     */
    private initEvents(): void
    {

        this.$form.on('change', 'input', (evt) => {
            this.clearError($(evt.currentTarget));
        });

        this.$form.on('change', 'textarea', (evt) => {
            this.clearError($(evt.currentTarget));
        });

        this.$form.on('change', 'select',  (evt) => {
            if ($(evt.currentTarget).find('option:selected').val() === '0') {
                this.$holder.find(this.selectors.additionalFieldSelectWrapper).addClass(this.SHOW_ADDITIONAL_FIELD);
            } else {
                this.$holder.find(this.selectors.additionalFieldSelectWrapper).removeClass(this.SHOW_ADDITIONAL_FIELD);
            }
            this.clearError($(evt.currentTarget));
        });

        /**
         * Отправка формы
         */
        this.$form.on('submit', (event) => {
            event.preventDefault();
            this.submit();
        });
    }
}
